// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.gallery-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-bottom: 30px;


    overflow-x: hidden;
}

.gallery {
    display: flex;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    gap: 90px;
    height: 700px;
    padding: 10px 0 20px 20px;
    overflow-x: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.rep-card-wrapper {
    flex: 0 0 auto;
    margin-right: 10px;
}

.slider-dots {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    gap: 8.4px;
    display: none;
}

.dot {
    background-color: #ccc;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease; /* Add this line */
}

.dot.active {
    background-color: var(--primitive-red);
}

.scroll-buttons {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    gap: 20px;
    z-index: 100;
}

.scroll-button {

    background-color: transparent;
    padding: 10px;
    cursor: pointer;
    height: 51px;
    width: 52px;
    border-radius: 52.5px;
    border: 1.05px solid var(--Border-primary, #000);
}

/* Hide scrollbar for WebKit browsers (Chrome, Safari) */
.gallery::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for Internet Explorer and Edge */
.gallery {
    -ms-overflow-style: none;
}

/* Hide scrollbar for Firefox */
.gallery {
    scrollbar-width: none;
}

.gallery-holder {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 1512px;
    width: 100vw;
    gap: 10px;
    margin: 0 auto;
    padding-left: 10px;
}

.gallery-holder .title-wrap {
    display: flex;
    padding: 45.3px 0px 0px 10px;
    flex-direction: column;
    gap: 15.7px;
    width: 100%;
}

.gallery-holder .title {
    color: var(--Text-primary, #000);
    font-size: 50.4px;
    font-weight: 700;
    line-height: 120%;
}

.gallery-holder .text {
    color: var(--Text-primary, #000);
    font-size: 18px;
    font-weight: 400;
    line-height: 150%;
}

.gallery-holder .slider {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    padding-left: 0px;
    width: 100%;
}

.gallery-holder .gallery {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    overflow-x: scroll;
    scroll-behavior: smooth;
    align-items: center;
    height: 100%;
    width: 100%;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.gallery-holder .gallery::-webkit-scrollbar {
    display: none;
}

@media (max-width: 1224px) {
    .gallery-holder .slider,
    .gallery-holder .gallery {
        height: 460px !important;
    }
}

.rep-card-link {
    text-decoration: none;
    color: inherit;
}

.rep-card-link:hover,
.rep-card-link:visited {
    text-decoration: none;
    color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/RepGallery/style.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;;;IAGpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iCAAiC;IACjC,WAAW;IACX,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sCAAsC,EAAE,kBAAkB;AAC9D;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA,wDAAwD;AACxD;IACI,aAAa;AACjB;;AAEA,kDAAkD;AAClD;IACI,wBAAwB;AAC5B;;AAEA,+BAA+B;AAC/B;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;;QAEI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":["body {\n    font-family: Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.gallery-container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    padding-bottom: 30px;\n\n\n    overflow-x: hidden;\n}\n\n.gallery {\n    display: flex;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    width: 100%;\n    gap: 90px;\n    height: 700px;\n    padding: 10px 0 20px 20px;\n    overflow-x: scroll;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n}\n\n.rep-card-wrapper {\n    flex: 0 0 auto;\n    margin-right: 10px;\n}\n\n.slider-dots {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n    gap: 8.4px;\n    display: none;\n}\n\n.dot {\n    background-color: #ccc;\n    border-radius: 50%;\n    width: 10px;\n    height: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease; /* Add this line */\n}\n\n.dot.active {\n    background-color: var(--primitive-red);\n}\n\n.scroll-buttons {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n    gap: 20px;\n    z-index: 100;\n}\n\n.scroll-button {\n\n    background-color: transparent;\n    padding: 10px;\n    cursor: pointer;\n    height: 51px;\n    width: 52px;\n    border-radius: 52.5px;\n    border: 1.05px solid var(--Border-primary, #000);\n}\n\n/* Hide scrollbar for WebKit browsers (Chrome, Safari) */\n.gallery::-webkit-scrollbar {\n    display: none;\n}\n\n/* Hide scrollbar for Internet Explorer and Edge */\n.gallery {\n    -ms-overflow-style: none;\n}\n\n/* Hide scrollbar for Firefox */\n.gallery {\n    scrollbar-width: none;\n}\n\n.gallery-holder {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 1512px;\n    width: 100vw;\n    gap: 10px;\n    margin: 0 auto;\n    padding-left: 10px;\n}\n\n.gallery-holder .title-wrap {\n    display: flex;\n    padding: 45.3px 0px 0px 10px;\n    flex-direction: column;\n    gap: 15.7px;\n    width: 100%;\n}\n\n.gallery-holder .title {\n    color: var(--Text-primary, #000);\n    font-size: 50.4px;\n    font-weight: 700;\n    line-height: 120%;\n}\n\n.gallery-holder .text {\n    color: var(--Text-primary, #000);\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 150%;\n}\n\n.gallery-holder .slider {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    height: 100%;\n    padding-left: 0px;\n    width: 100%;\n}\n\n.gallery-holder .gallery {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 16px;\n    overflow-x: scroll;\n    scroll-behavior: smooth;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n}\n\n.gallery-holder .gallery::-webkit-scrollbar {\n    display: none;\n}\n\n@media (max-width: 1224px) {\n    .gallery-holder .slider,\n    .gallery-holder .gallery {\n        height: 460px !important;\n    }\n}\n\n.rep-card-link {\n    text-decoration: none;\n    color: inherit;\n}\n\n.rep-card-link:hover,\n.rep-card-link:visited {\n    text-decoration: none;\n    color: inherit;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
